import httpLocal from '../utils/http-local'

export const getPrinters = () => {
  return httpLocal.get('/printers')
}

export const print = (data) => {
  return httpLocal.post('/printers/print', data)
}

export const getScales = () => {
  return httpLocal.get('/scales/scales')
}

export const getWeight = () => {
  return httpLocal.get('/scales/weight')
}

export const setAutoPrint = (data) => {
  return httpLocal.post('/scales/setAutoPrint', data)
}

export const getDevices = () => {
  return httpLocal.get('/settings')
}

export const setDevice = (data) => {
  return httpLocal.post('/settings', data)
}

const PrintDataService = {
  getPrinters,
  print,
  getScales,
  getWeight,
  setAutoPrint,
  getDevices,
  setDevice,
}

export default PrintDataService
